import * as React from 'react';
import { useCtx } from 'one-ui-provider';
import Button from 'antd/lib/button';
import invertphone from "one-ui-svg/images/invertphone.png";

export const CardVerifySource = (
    props: any
): JSX.Element => {
    const { resolver } = useCtx();
    const { onClick } = props
    return (
        <div className="card-verify-div" >
            <img
                src={resolver(invertphone)}
                width={64} height={50}
                draggable="false"
            />
            <br />
            <a>
                <Button className="card-verify-btn" onClick={onClick}>
                    <p className="card-verify-source-button" >Verify Source</p>
                </Button>
            </a>
    </div>
    );
};  
